import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Cursor Events',
      type: 'metric',
      content: {
        '{}': {
          name: 'Cursor Events',
          value: {
            '{}': {
              aside: 'events',
              quality: 'neutral',
              tooltip: 'Event count for the selected project or all projects.',
              emphasis: {
                'fmt.num': [
                  {
                    '#': {
                      '@': 'cursorEventIds',
                    },
                  },
                  {
                    ',': true,
                    '.': {
                      always: 0,
                    },
                  },
                ],
              },
            },
          },
          description: 'Total number of recorded Cursor usage events.',
        },
      },
    },
  },
  subqueries: {
    cursorEventIds: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'projectId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!project',
                  {
                    ref: {
                      entity: '!proj',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'projectId',
                  },
                  'ent:!projects:!proj',
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!cursor_usage_events:!cursor_usage_event',
      selection: {
        '@.': '!id',
      },
    },
  },
}
